const interceptSelectedGame = (store) => (next) => (action) => {
  if (action.type === 'settlements/setSelectedGame') {
    if (action.payload !== store.getState().settlements.selectedGame) {
      next(action);
    }
  } else next(action);
};

export default interceptSelectedGame;
